// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, {SEOHead} from "../../layouts/default";
import { FaqTemplate, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import aauImg from "../../../public/images/aau.jpg";

const AddAuthedUser = () => (
  <Layout>
    <SEOHead title="Add Authed User" />
    <FaqTemplate title="Add Authorized User">
      <FaqP>
        Use the form below to add a new Authorized User to your account.
      </FaqP>
      <FaqP>
        Authorized Users can access the following account information:
      </FaqP>
      <FaqP>
        <ul>
          <li>Billing History</li>
          <li>Payment Information</li>
          <li>Change Plan / Speed</li>
          <li>Report Service Issues</li>
        </ul>
      </FaqP>
      <FaqP>
        Authorized Users do NOT have access to the following account
        information:
      </FaqP>
      <FaqP>
        <ul>
          <li>Service Move Orders</li>
          <li>Adding New Authorized Users</li>
          <li>Cancelling Service</li>
        </ul>
      </FaqP>

      <Image
        src={aauImg}
        alt="Add Authorized User"
        className="img-fluid"
        placeholder="blur"
      />
    </FaqTemplate>
  </Layout>
);

export default AddAuthedUser;
